module.exports = __webpack_public_path__ + "assets/img/datu1.dbfe14fe.jpg";